(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 89894:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _head = _interop_require_default(__webpack_require__(16505));

var statusCodes = {
  400: 'Bad Request',
  404: 'This page could not be found',
  405: 'Method Not Allowed',
  500: 'Internal Server Error'
};

function _getInitialProps(_ref) {
  var res = _ref.res,
      err = _ref.err;
  var statusCode = res && res.statusCode ? res.statusCode : err ? err.statusCode : 404;
  return {
    statusCode: statusCode
  };
}

var styles = {
  error: {
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
    height: '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  desc: {
    display: 'inline-block',
    textAlign: 'left',
    lineHeight: '49px',
    height: '49px',
    verticalAlign: 'middle'
  },
  h1: {
    display: 'inline-block',
    margin: 0,
    marginRight: '20px',
    padding: '0 23px 0 0',
    fontSize: '24px',
    fontWeight: 500,
    verticalAlign: 'top',
    lineHeight: '49px'
  },
  h2: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '49px',
    margin: 0,
    padding: 0
  }
};

var _Component;

var Error = /*#__PURE__*/function (_Component2) {
  _inherits(Error, _Component2);

  var _super = _createSuper(Error);

  function Error() {
    _classCallCheck(this, Error);

    return _super.apply(this, arguments);
  }

  _createClass(Error, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          statusCode = _this$props.statusCode,
          _this$props$withDarkM = _this$props.withDarkMode,
          withDarkMode = _this$props$withDarkM === void 0 ? true : _this$props$withDarkM;
      var title = this.props.title || statusCodes[statusCode] || 'An unexpected error has occurred';
      return /*#__PURE__*/_react.default.createElement("div", {
        style: styles.error
      }, /*#__PURE__*/_react.default.createElement(_head.default, null, /*#__PURE__*/_react.default.createElement("title", null, statusCode ? "".concat(statusCode, ": ").concat(title) : 'Application error: a client-side exception has occurred')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "\n                body { margin: 0; color: #000; background: #fff; }\n                .next-error-h1 {\n                  border-right: 1px solid rgba(0, 0, 0, .3);\n                }\n\n                ".concat(withDarkMode ? "@media (prefers-color-scheme: dark) {\n                  body { color: #fff; background: #000; }\n                  .next-error-h1 {\n                    border-right: 1px solid rgba(255, 255, 255, .3);\n                  }\n                }" : '')
        }
      }), statusCode ? /*#__PURE__*/_react.default.createElement("h1", {
        className: "next-error-h1",
        style: styles.h1
      }, statusCode) : null, /*#__PURE__*/_react.default.createElement("div", {
        style: styles.desc
      }, /*#__PURE__*/_react.default.createElement("h2", {
        style: styles.h2
      }, this.props.title || statusCode ? title : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Application error: a client-side exception has occurred (see the browser console for more information)"), "."))));
    }
  }]);

  return Error;
}(_Component = _react.default.Component);

Error.displayName = 'ErrorPage';
Error.getInitialProps = _getInitialProps;
Error.origGetInitialProps = _getInitialProps;
exports["default"] = Error;

/***/ }),

/***/ 49948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var _src_utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74194);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);








var MyError = function MyError(_ref) {
  var statusCode = _ref.statusCode,
      hasGetInitialPropsRun = _ref.hasGetInitialPropsRun,
      err = _ref.err;

  if (!hasGetInitialPropsRun && err) {
    // getInitialProps is not called in case of
    // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
    // err via _app.js so it can be captured
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err); // Flushing is not required in this case as it only happens on the client
  }

  statusCode ? _src_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .log.info */ .c.info('rendering error page with status code:', statusCode) : _src_utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .log.trace */ .c.trace('rendering error page without status code');
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
    statusCode: statusCode
  });
};

MyError.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_app_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
    var _yield$Error$getIniti, statusCode, title, errorInitialProps, res, err, asPath;

    return _app_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return next_error__WEBPACK_IMPORTED_MODULE_2__["default"].getInitialProps(context);

          case 2:
            _yield$Error$getIniti = _context.sent;
            statusCode = _yield$Error$getIniti.statusCode;
            title = _yield$Error$getIniti.title;
            errorInitialProps = {
              statusCode: statusCode,
              title: title,
              hasGetInitialPropsRun: false
            };
            res = context.res, err = context.err, asPath = context.asPath; // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
            // getInitialProps has run

            errorInitialProps.hasGetInitialPropsRun = true; // Returning early because we don't want to log 404 errors to Sentry.

            if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 404)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", errorInitialProps);

          case 10:
            if (!err) {
              _context.next = 15;
              break;
            }

            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err); // Flushing before returning is necessary if deploying to Vercel, see
            // https://vercel.com/docs/platform/limits#streaming-responses

            _context.next = 14;
            return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .flush */ .yl(2000);

          case 14:
            return _context.abrupt("return", errorInitialProps);

          case 15:
            // If this point is reached, getInitialProps was called without any
            // information about what the error might be. This is unexpected and may
            // indicate a bug introduced in Next.js, so record it in Sentry
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb('_error.js getInitialProps missing data at path: ' + asPath);
            _context.next = 18;
            return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .flush */ .yl(2000);

          case 18:
            return _context.abrupt("return", errorInitialProps);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (MyError);

/***/ }),

/***/ 5353:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(49948);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89894)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(5353); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);